module.exports = __webpack_public_path__ + "img/apple-appstore-logo.6c1465d6.png";